import React, { useRef, useEffect } from "react";
import { useController } from "react-hook-form";
import { GdkFein } from "@gdk/fein";
import TooltipLabel from "./TooltipLabel";
import { classes } from "../../util/style-utils";
import $ from 'jquery';

export default function Fein({
    control,
    name = "fein",
    label = "Federal Employer Identification Number (FEIN)",
    disabled = false,
    trackingId
}) {
    const federalEmploymentIdentificationNumber = useRef();

    const {
        field: { onChange, onBlur, value, ref },
        fieldState: { error }
    } = useController({
        name,
        control,
        defaultValue: ""
    });

    useEffect(() => {
        federalEmploymentIdentificationNumber.current = new GdkFein({
            content: `#${name}-container`
        });

        federalEmploymentIdentificationNumber.current.setFederalIdentificationNumber(value);

        $(`#${name}-container input[type=tel]`).on("change", function () {
            onChange(federalEmploymentIdentificationNumber.current.getFederalIdentificationNumber());
        });

        $(`#${name}-container input[type=tel]`).on("blur", onBlur);
    }, [name]);

    return (
        <div data-onboarding-control-id={trackingId} className={classes("form-field", error && "form-field--error")} id={`${name}-container`}>
            <div className={classes("federal-employment-identification-number-wrapper form-field", error && "form-field--error")}>
                <TooltipLabel
                    htmlFor={`${name}-input-field`}
                    label={label}
                    content={
                        <>
                            At GEICO, we understand the importance of your privacy and security. The information you{" "}
                            provide will be kept confidential and secure. It will not be sold or redistributed. To{" "}
                            learn more about how we protect your personal information, please review our privacy{" "}
                            &amp; security policy:{" "}
                            <a data-onboarding-link-id="gdk:Fein:PrivacyPolicy" href="https://media.geico.com/legal/privacy_policy.htm" target="_blank" rel="noopener noreferrer" className="">
                                Privacy Policy
                            </a>
                        </>
                    }
                />
                <input
                    id={`${name}-input-field`}
                    type="tel"
                    className="federal-employment-identification-number"
                    autoComplete="off"
                    spellCheck="false"
                    placeholder="__-_______"
                    ref={ref}
                    disabled={disabled}
                />
                <input
                    type="password"
                    id={`${name}-input-value`}
                    name={`${name}-input-value`}
                    className="secureInput"
                    maxLength="11"
                    autoComplete="off"
                    spellCheck="false"
                    readOnly
                />
                {/* Temporary fix to hide show/hide toggle for FEIN until we can implement proper masking for disabled FEIN. */}
                <span data-onboarding-button-id="Fein:ToggleVisibility" className="fein-show-hide" hidden={disabled}>
                    <span className="icon-hide" aria-label="Hide"></span>
                </span>
                {error && (
                    <span className="form-message">
                        {error.message}
                    </span>
                )}
            </div>
        </div>
    );
}